import type { FilterFn } from "@tanstack/react-table";

function isCheckboxFilterEmpty(value: unknown): boolean {
  return !Array.isArray(value) || value.length === 0;
}

// Mirrors createNumberRangeFilterFn: the actual filtering happens server-side
// (manualFiltering), so the row check is a no-op. autoRemove is what keeps an
// active `string[]` filter value from being dropped from columnFilters state.
export function createCheckboxFilterFn<TData>(): FilterFn<TData> {
  const filterFn: FilterFn<TData> = () => true;
  filterFn.autoRemove = isCheckboxFilterEmpty;
  return filterFn;
}
